<section class="py-5">
    <div class="py-3 container">
        <div class="row">
            <div class="col-md-12">
                <div class="title">
                    <h1 class="fw-bold text-black">Privacy Policy</h1>
                    <p class="py-2 fw-bold text-black">Last updated on 12<sup>th</sup> July 2025</p>
                </div>

                <div class="py-4">
                    <p class="txt-description mb-4 text-secondary">
                      This Privacy Policy describes how <strong>Goodsketches</strong> (“Company”, “We”, “Us”, or “Our”), which operates
                        <a class="un-link" href="https://www.illusbook.com">www.illusbook.com</a> (“Platform”), collects, uses, stores, and protects your personal information. We are committed to ensuring your privacy and complying with applicable Indian laws, including the Information Technology Act, 2000 and related rules.
                    </p>

                     <h2 class="txt-title fs-4 mb-4 text-black">
                        Business Information
                    </h2>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                            Business Name: Goodsketches
                        </li>
                        <li class="mb-3">
                            Platform Name: Illusbook
                        </li>
                        <li class="mb-3">
                            Website: <a class="un-link bold" href="https://www.illusbook.com/">www.illusbook.com</a>
                        </li>
                        <li class="mb-3">
                            Nature of Business: Digital illustration platform offering downloadable design assets
                        </li>
                        <li class="mb-3">
                            Registered Address:
                            135, Greenfield's Crown City, Phase II, Sathy Main Road,
                            Kovilpalayam, Coimbatore – 641107, Tamil Nadu, India
                        </li>
                        <li class="mb-3">
                          Contact Email: <a class="un-link bold" href="mailto:support@illusbook.com">support&#64;illusbook.com</a>
                        </li>
                    </ul>

                     <h2 class="txt-title fs-4 mb-4 text-black">
                       Information We Collect
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                       We may collect and store the following categories of information:
                    </p>

                     <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                          Personal Information: Name, email address, payment details(processed securely via third-party gateways like Razorpay), and Account login details (if you register)
                        </li>
                        <li class="mb-3">
                           Usage & Technical Data: Device info, IP address, browser type, time spent on pages, downloads, and interactions.
                        </li>
                        <li class="mb-3">
                           Cookies and Tracking Technologies: For improving performance, user experience, Enable session management, personalization, and analytics (via tools like Google Analytics).
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Purpose of Data Collection
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                       We collect and use your information to:
                    </p>

                     <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                          Register and manage your account
                        </li>
                        <li class="mb-3">
                         Process and fulfill payments/subscriptions securely
                        </li>
                        <li class="mb-3">
                          Provide access to digital assets and platform features
                        </li>
                        <li class="mb-3">
                          Communicate important service updates or offers
                        </li>
                        <li class="mb-3">
                          Prevent misuse or fraudulent activity
                        </li>
                         <li class="mb-3">
                          Comply with legal obligations
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                      Data Sharing and Disclosure
                    </h2>


                    <p class="txt-description mb-4 text-secondary">
                     We do not sell or rent your personal data. We may share your data only in the following cases:
                    </p>

                     <ul class="txt-description mb-4 text-secondary">
                        <li class="mb-3">
                      With trusted service providers (e.g., Razorpay, cloud hosting partners like Firebase, analytics tools) under confidentiality agreements
                        </li>
                        <li class="mb-3">
                       When required by law, court order, or government authorities
                        </li>
                         <li class="mb-3">
                      To enforce our Terms of Use or investigate potential violations
                        </li>
                    </ul>

                     <p class="txt-description mb-5 text-secondary">
                    All third parties are bound by data protection obligations.
                    </p>

                     <h2 class="txt-title fs-4 mb-4 text-black">
                        Data Security
                    </h2>


                    <p class="txt-description mb-4 text-secondary">
                   We use industry-standard technologies and measures to protect your data, including:
                    </p>

                    <ul class="txt-description mb-4 text-secondary">
                        <li class="mb-3">
                      Secure APIs
                        </li>
                        <li class="mb-3">
                        Encrypted payment processing (e.g., Razorpay)
                        </li>
                         <li class="mb-3">
                        Cloud storage via trusted providers (e.g., Firebase)
                        </li>
                    </ul>

                     <p class="txt-description mb-5 text-secondary">
                   While we implement strong security measures and trusted infrastructure to protect your personal data, we encourage users to follow safe browsing practices and understand that no digital service can be entirely risk-free.
                    </p>

                     <h2 class="txt-title fs-4 mb-4 text-black">
                        Your Choices
                    </h2>


                    <p class="txt-description mb-4 text-secondary">
                     You have the right to:
                    </p>

                    <ul class="txt-description mb-4 text-secondary">
                        <li class="mb-3">
                       Access or update your personal information
                        </li>
                        <li class="mb-3">
                         Opt out of marketing or promotional emails
                        </li>
                         <li class="mb-3">
                         Request deletion or correction of your data (subject to legal requirements)
                        </li>
                    </ul>

                    <p class="txt-description mb-5 text-secondary">
                    You can do this via your Illusbook account settings or by writing to <a class="un-link bold"
                                href="mailto:support@illusbook.com">support&#64;illusbook.com</a>
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                      Children’s Privacy
                    </h2>


                    <p class="txt-description mb-5 text-secondary">
                     Illusbook is not intended for children under 13 years of age. We do not knowingly collect personal data from minors. If we become aware that a child has submitted information, we will promptly delete it.
                    </p>

                     <h2 class="txt-title fs-4 mb-4 text-black">
                      Policy Updates
                    </h2>


                    <p class="txt-description mb-4 text-secondary">
                   We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated date. Continued use of the platform after such changes implies acceptance of the revised policy.
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                      Grievance Redressal (as per IT Act 2000)
                    </h2>


                    <p class="txt-description mb-4 text-secondary">
                In accordance with Indian law, you may contact our Grievance Officer for any complaints, concerns, or data-related issues:
                    </p>

                     <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                         Grievance Officer: Illusbook Support Team  
                        </li>
                        <li class="mb-3">
                         Email: support@illusbook.com  
                        </li>
                        <li class="mb-3">
                          Resolution Time: Within 7 working days
                        </li>
                    </ul>


                     <h2 class="txt-title fs-4 mb-4 text-black">
                     Contact Us
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                       If you have any questions about this Privacy Policy or how your data is handled, you can reach out to us at:
                        <a class="un-link bold" href="mailto:support@illusbook.com">support&#64;illusbook.com</a>
                         <br> <br>

                        <strong class="bold">Goodsketches</strong>, <br>
                        135, Greenfield's Crown City, Phase II, Sathy Main Road, Kovilpalayam, <br>
                        Coimbatore - 641107 Tamil Nadu,<br>
                        India.
                    </p>


                </div>
            </div>
        </div>
    </div>
</section>